import PageHero from 'components/ui/PageHero';

export default function StoryHero() {
  return (
    <PageHero
      eyebrow="THE Mora JOURNEY"
      title="More Than a Snack."
      subtitle="A Taste of Home."
      description="A brand born from a simple idea to bring back the warmth, taste and comfort of home through premium roasted peanuts. Every peanut carries a story, a memory, and a connection to our roots."
    />
  );
}
